/* eslint-disable react-hooks/exhaustive-deps */
import { RouteEnums } from '@Helper/Enums';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import { Button, IconButton, Menu, MenuItem } from '@mui/material';
import { NestedMenuItem } from 'mui-nested-menu';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Icons } from '../../../../assets/SvgIcons';
import { PageType } from '../../../../config/enum';
import { Section } from '../../../../config/section';
import { ComponentHelper } from '../../../../helper/Infra';
import { ICTask } from '../../../../helper/Interfaces';
import { getPlayBookDetail } from '../../../../store/feature/playBookDetailSlice';
import { deleteTaskHistory } from '../../../../store/feature/taskSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { Undo } from '../../TodoCard/components/DeleteDialog';
import classes from '../TodoTable.module.css';

const componentHelper = new ComponentHelper();

type MoreMenuProps = {
  task: ICTask;
  updateTaskSection?: (currentTask: ICTask, sectionId: string) => void;
  deleteTask?: (task: ICTask, stopDelete?: string, requestBody?: any) => void;
  disabled?: boolean;
  pageType?: PageType;
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
  renameTask?: (task: ICTask) => void;
};

const MoreMenu: FC<MoreMenuProps> = ({
  task,
  updateTaskSection,
  deleteTask,
  disabled,
  pageType,
  updateTaskProperty,
  renameTask,
}) => {
  const { id, pid, tabNumber } = useParams();

  const dispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [undoRequest, setUndoRequest] = useState<any>({});
  const nestedOpen = Boolean(anchorEl);
  const { sectionList } = useAppSelector(getPlayBookDetail);

  const [sectionStateList, setsectionStateList] = useState<Section[]>([]);

  const openMoreMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const closeMoreMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (open && sectionList && sectionList.length > 0) {
      const newElem = JSON.parse(JSON.stringify(sectionList)) as Section[];
      const sortedOnes = newElem.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      });
      setsectionStateList(sortedOnes);
    }
  }, [open, nestedOpen]);

  function reducer(state: any, action: any) {
    switch (action.type) {
      case 'init':
        if (deleteTask) {
          const deleteResponse = deleteTask(task, 'init');
          setUndoRequest(deleteResponse);
        }
        return {
          collection: state,
          toRemove: [...state.toRemove, action.id],
        };
      case 'normal':
        if (deleteTask) deleteTask(task, 'normal');
        return {
          collection: state,
          toRemove: [],
        };
      case 'break':
        if (deleteTask) deleteTask(task, 'break', undoRequest);
        return {
          collection: state,
          toRemove: [],
        };
      default:
        return state;
    }
  }

  const [, deleteDispatch] = React.useReducer(reducer, {
    collection: task,
    toRemove: [],
  });

  return (
    <div>
      <IconButton aria-label="delete" size="small" onClick={openMoreMenu}>
        <MoreHorizIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closeMoreMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        PaperProps={{
          style: {
            background: '#ffffff',
            border: ' 1px solid #ebebf0',
            boxSizing: 'border-box',
            boxShadow: ' 0px 8px 16px rgba(0, 0, 0, 0.1)',
            borderRadius: 4,
            padding: '8px 8px 6px',
            width: 208,
          },
        }}
      >
        <div className={classes.moreMenuCopy}>
          <Button
            variant="outlined"
            onClick={() => {
              componentHelper.unsecuredCopyToClipboard(
                window.location.origin +
                  RouteEnums.Playbook +
                  id +
                  '/' +
                  pid +
                  '/' +
                  tabNumber +
                  '?selectedIssue=' +
                  task?.itemNumber
              );
              closeMoreMenu();
            }}
          >
            Copy Link
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              componentHelper.unsecuredCopyToClipboard(task.id || '');
              closeMoreMenu();
            }}
          >
            Copy ID
          </Button>
        </div>
        {pageType && pageType === PageType.ARCHIVE ? null : (
          <div>
            {task.type && task.type !== 'dependency' && (
              <MenuItem
                className={classes.moreMenuItem}
                onClick={() => {
                  renameTask && renameTask(task);
                  closeMoreMenu();
                }}
                disabled={disabled}
              >
                <Icons.Rename /> <span>Rename</span>
              </MenuItem>
            )}
            {task.type &&
            !['decision', 'issue', 'risk', 'dependency'].includes(task.type) &&
            task.parentId ? (
              <MenuItem
                className={classes.moreMenuItem}
                onClick={() => {
                  closeMoreMenu();
                  if (updateTaskProperty) {
                    updateTaskProperty(task.id ?? '', 'parentId', null);
                  }
                }}
                disabled={disabled}
              >
                <MoveUpIcon /> <span>Make First Level Task</span>
              </MenuItem>
            ) : (
              <div></div>
            )}

            {task.parentId === null &&
            sectionStateList.filter(i => i.id !== task.sectionId).length > 0 ? (
              <NestedMenuItem
                parentMenuOpen={nestedOpen}
                label="Change Section"
                leftIcon={
                  <span className={classes.noSvg}>
                    <Icons.Move />
                  </span>
                }
                className={[classes.moreMenuItem, 'nested-menu'].join(' ')}
                disabled={disabled}
                rightIcon={
                  <span className={classes.moreMenuItemRightIcon}>
                    <Icons.ChevronRight color="#6E6B8C" />
                  </span>
                }
                MenuProps={{
                  className: 'nested-menu',
                }}
              >
                <div className="nested-menu-content">
                  {sectionStateList
                    .filter(i => i.id !== task.sectionId)
                    .map(section => {
                      return (
                        <MenuItem
                          sx={{ pl: 4 }}
                          className={[classes.moreMenuItem].join(' ')}
                          onClick={() => {
                            if (updateTaskSection)
                              updateTaskSection(task, section.id);
                            closeMoreMenu();
                          }}
                          key={section.id}
                        >
                          <span className="ellipsisLine1">{section.name}</span>
                        </MenuItem>
                      );
                    })}
                </div>
              </NestedMenuItem>
            ) : (
              <div></div>
            )}
            {task.parentId === null || task.type === 'subtask' ? (
              <MenuItem
                className={[classes.moreMenuItem].join(' ')}
                onClick={() => {
                  closeMoreMenu();
                  if (updateTaskProperty) {
                    updateTaskProperty(task.id!, 'isArchived', true);
                    toast(task.itemNumber + ' has successfully been archived');
                  }
                }}
                disabled={disabled}
              >
                <Icons.Archive /> <span>Archive Task</span>
              </MenuItem>
            ) : (
              <div></div>
            )}
            {deleteTask && (
              <MenuItem
                className={classes.moreMenuItem}
                disabled={disabled}
                onClick={() => {
                  closeMoreMenu();
                  deleteDispatch({ task, type: 'init' });
                  dispatch(deleteTaskHistory(task.id ?? ''));
                  toast(
                    <Undo
                      onUndo={() => {
                        deleteDispatch({ task, type: 'break' });
                      }}
                      message="Successfully deleted"
                      taskName={task.name ?? ''}
                    />,
                    {
                      onClose: () => {
                        deleteDispatch({ task, type: 'normal' });
                      },
                    }
                  );
                }}
              >
                <Icons.Delete2 color="#FF5630" />
                <span style={{ color: '#FF5630' }}>Delete</span>
              </MenuItem>
            )}
          </div>
        )}
      </Menu>
    </div>
  );
};

export default MoreMenu;
